import React from 'react';

import { LoginContainer } from '../../containers';

const Login = (props) => <LoginContainer {...props} />;

export default Login;
